import React, { useEffect, useMemo, useState } from "react";
import citizenTotal from "../../../../assets/images/citizen-total.png";
import serviceClosed from "../../../../assets/images/service-closed.png";
import servicePending from "../../../../assets/images/service-pending.png";
import { getServiceSummary } from "../../../Apis/DashboardApis/primaryDashboardApi";
import CardLoader from "../../../Common/ShimmerLoader/CardLoader";
import DashboardSectionCard from "./shared/DashboardSectionCard";
import DashboardFilters from "./shared/DashboardFilters";
import MetricStat from "./shared/MetricStat";
import useDashboardFilters from "./shared/useDashboardFilters";

const formatCount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return Number(value).toLocaleString();
};

const buildStats = (summary) => [
  {
    iconSrc: citizenTotal,
    label: "Total Services",
    value: formatCount(summary?.totalServices),
    color: "#2563eb",
  },
  {
    iconSrc: serviceClosed,
    label: "Closed Services",
    value: formatCount(summary?.closedServices),
    color: "#16a34a",
  },
  {
    iconSrc: servicePending,
    label: "Pending Services",
    value: formatCount(summary?.pendingServices),
    color: "#ea580c",
  },
];

const ServiceSummary = ({ wards, data }) => {
  const {
    filters,
    appliedFilters,
    handleFilterChange,
    handleSearch,
  } = useDashboardFilters();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    if (Array.isArray(data)) {
      return undefined;
    }

    let isMounted = true;

    const fetchSummary = async () => {
      try {
        setLoading(true);
        const response = await getServiceSummary(appliedFilters);

        if (isMounted && response?.status) {
          setSummary(response?.data ?? null);
        }
      } catch (error) {
        console.error("Failed to load service summary:", error);
        if (isMounted) {
          setSummary(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchSummary();

    return () => {
      isMounted = false;
    };
  }, [appliedFilters, data]);

  const stats = useMemo(() => {
    if (Array.isArray(data)) {
      return data;
    }

    return buildStats(summary);
  }, [data, summary]);

  return (
    <DashboardSectionCard
      title="Service Summary"
      className="pd-service-summary-section"
      filters={
        <DashboardFilters
          className="pd-complaint-filters"
          searchVariant="inline"
          fromDate={filters?.fromDate}
          toDate={filters?.toDate}
          ward={filters?.ward}
          wards={wards}
          onFromDateChange={(value) => handleFilterChange("fromDate", value)}
          onToDateChange={(value) => handleFilterChange("toDate", value)}
          onWardChange={(value) => handleFilterChange("ward", value)}
          onSearch={handleSearch}
          showSearch
        />
      }
    >
      {loading ? (
        <CardLoader count={3} />
      ) : (
        <div className="pd-metric-row cols-3 pd-service-metrics-row">
          {stats.map((item) => (
            <MetricStat key={item.label} {...item} boxed />
          ))}
        </div>
      )}
    </DashboardSectionCard>
  );
};

export default ServiceSummary;
